module.exports = __webpack_public_path__ + "static/process_new_editor-3b91bacbdb82a632ffe873222223a3cc.svg";